const SENSITIVE_PATTERNS = [
  /password/gi,
  /token/gi,
  /secret/gi,
  /api[_-]?key/gi,
  /authorization/gi,
  /bearer/gi,
  /credential/gi,
  /session/gi,
  /cookie/gi,
];

const ALLOWED_ERROR_MESSAGES = [
  'Please enter a valid code to proceed.',
  'Invalid OTP code.',
  'OTP code has expired.',
  'OTP code has been used.',
  'Too many attempts. Please try again later.',
  'Failed to send code. Please try again.',
];

export const sanitizeErrorMessage = (errorMessage: string | unknown): string => {
  if (typeof errorMessage !== 'string') {
    return 'An error occurred. Please try again.';
  }

  const message = errorMessage.trim();

  if (!message) {
    return 'An error occurred. Please try again.';
  }

  for (const pattern of SENSITIVE_PATTERNS) {
    if (pattern.test(message)) {
      return 'An error occurred. Please try again.';
    }
  }

  if (
    ALLOWED_ERROR_MESSAGES.some((allowed) => message.toLowerCase().includes(allowed.toLowerCase()))
  ) {
    return message;
  }

  if (message.length > 200) {
    return message.substring(0, 200) + '...';
  }

  return message;
};

export const extractSanitizedApiError = (error: unknown, fallback: string): string => {
  const rawMessage =
    (error as { response?: { data?: { error?: string } } }).response?.data?.error ||
    (error as Error).message ||
    fallback;
  return sanitizeErrorMessage(rawMessage);
};
